import React, { useState } from 'react'

const TICKET_STATUS_OPTIONS = [
  { value: 'on_hold', label: 'On Hold' },
  { value: 'closed',  label: 'Closed'  },
]

const emptyForm = (resolvedData) => ({
  ticket_status:  resolvedData?.ticket_status  || '',
  issue_resolved: resolvedData?.issue_resolved || '',
})

export default function StationCloseForm({ resolvedData, readOnly, onSubmit, submitting }) {
  const [form, setForm] = useState(() => emptyForm(resolvedData))
  const [errors, setErrors] = useState({})

  const isClosed = form.ticket_status === 'closed'

  function set(field, value) {
    setForm((prev) => {
      const next = { ...prev, [field]: value }
      if (field === 'ticket_status' && value !== 'closed') next.issue_resolved = ''
      return next
    })
    setErrors((prev) => ({ ...prev, [field]: '' }))
  }

  function validate() {
    const e = {}
    if (!form.ticket_status)              e.ticket_status   = 'Required'
    if (isClosed && !form.issue_resolved) e.issue_resolved  = 'Required'
    return e
  }

  function handleSubmit(e) {
    e.preventDefault()
    const errs = validate()
    if (Object.keys(errs).length) { setErrors(errs); return }

    onSubmit({
      resolution_fields: {},
      ticket_status: form.ticket_status,
      ...(isClosed && { issue_resolved: form.issue_resolved }),
    })
  }

  return (
    <form className="ctf-section" onSubmit={handleSubmit} noValidate>

      {readOnly && (
        <div className="ctf-readonly-banner">
          &#128274; This ticket is closed — view only
        </div>
      )}

      {/* Ticket Status */}
      <Field label="Ticket Status" required={!readOnly} error={errors.ticket_status}>
        <select
          className="ctf-select"
          value={form.ticket_status}
          onChange={(e) => set('ticket_status', e.target.value)}
          disabled={readOnly}
        >
          <option value="">Select status</option>
          {TICKET_STATUS_OPTIONS.map((o) => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </select>
      </Field>

      {/* Issue Resolved — only active when ticket_status is closed */}
      <Field
        label="Issue Resolved"
        required={isClosed && !readOnly}
        error={errors.issue_resolved}
        hint={!isClosed && !readOnly ? 'Available only when Ticket Status is Closed' : undefined}
      >
        <div className={`ctf-radio-group ${(!isClosed || readOnly) ? 'ctf-radio-group--disabled' : ''}`}>
          {['yes', 'no'].map((v) => (
            <label key={v} className="ctf-radio-label">
              <input
                type="radio"
                name="issue_resolved"
                value={v}
                checked={form.issue_resolved === v}
                disabled={!isClosed || readOnly}
                onChange={() => set('issue_resolved', v)}
                className="ctf-radio"
              />
              {v === 'yes' ? 'Yes' : 'No'}
            </label>
          ))}
        </div>
      </Field>

      {!readOnly && (
        <button type="submit" className="ctf-submit-btn" disabled={submitting}>
          {submitting ? 'Submitting…' : 'Update Ticket'}
        </button>
      )}
    </form>
  )
}

function Field({ label, required, error, hint, children }) {
  return (
    <div className="ctf-field">
      <span className="ctf-label">
        {label}
        {required && <span className="ctf-required">*</span>}
      </span>
      {children}
      {hint  && !error && <span className="ctf-hint">{hint}</span>}
      {error && <span className="ctf-field-error">{error}</span>}
    </div>
  )
}
